import {
	type ApplicationKey,
	SERVICE_DESK,
	CORE,
	SOFTWARE,
	PRODUCT_DISCOVERY,
} from '@atlassian/jira-shared-types/src/application-key.tsx';
import type { TenantContext } from '@atlassian/jira-shared-types/src/tenant-context.tsx';

const getExplicitlyLicensedProducts = (tenantContext: TenantContext): ApplicationKey[] => {
	const { licensedProducts } = tenantContext;
	const result: ApplicationKey[] = [];
	licensedProducts[CORE] && result.push(CORE);
	licensedProducts[SERVICE_DESK] && result.push(SERVICE_DESK);
	licensedProducts[SOFTWARE] && result.push(SOFTWARE);
	licensedProducts[PRODUCT_DISCOVERY] && result.push(PRODUCT_DISCOVERY);
	return result;
};

export default getExplicitlyLicensedProducts;
